module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = 47
// module chunks = 12